import Icon from '@atoms/Icon/Icon';
import { IconName } from '@models/IIcon';
import IconSizeEnum from '@models/enums/IconSizeEnum';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';

interface Props {
  readonly text: string;
  readonly quoteIcon: IconName;
  readonly author: string;
  readonly displayQuote: boolean;
  readonly intro?: string;
  readonly outro?: string;
}

const Quote = ({
  text,
  quoteIcon,
  author,
  displayQuote,
  intro,
  outro,
}: Props) => {
  if (!displayQuote) return null;

  return (
    <section className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white">
      <SoftLoadWrapper>
        <div className="container">
          <div className="grid lg:grid-cols-12">
            {intro && (
              <p className="body-one mb-13 text-grey-450 lg:col-start-2 lg:col-end-8 lg:mb-15 dark:text-grey-400">
                {intro}
              </p>
            )}
            <figure className="relative bg-white pr-8 pl-12 content-area lg:col-start-2 lg:col-end-8 dark:bg-black-100">
              {quoteIcon && (
                <span className="absolute left-0 translate-y-1 text-yellow">
                  <Icon
                    name={quoteIcon}
                    colorClassName="text-yellow"
                    size={IconSizeEnum.lg}
                  />
                </span>
              )}
              {text && (
                <blockquote className="pb-[22px]">
                  <span
                    className="h6"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </blockquote>
              )}
              {author && (
                <figcaption className="body-three font-thin">
                  {author}
                </figcaption>
              )}
            </figure>
            {outro && (
              <p className="body-one mt-13 text-grey-450 lg:col-start-2 lg:col-end-8 lg:mt-15 dark:text-grey-400">
                {outro}
              </p>
            )}
          </div>
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default Quote;
